"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OlapicGallery = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../api");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _utils = require("../../utils");
var _LoadMore = require("../LoadMore");
var _MediaItem = require("../MediaItem");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OlapicGallery = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    mediaItems,
    setLoadMoreUrl,
    setMediaItems,
    loadMoreUrl
  } = (0, _contexts.useOlapicData)();
  const {
    onOpenDetails
  } = (0, _contexts.useOlapicDetails)();
  const {
    getMediaItems,
    isLoading
  } = (0, _api.useLoadMoreMedia)();
  const loadMore = (0, _react.useCallback)(async () => {
    if (!isLoading && loadMoreUrl) {
      (0, _utils.createUserActionEvent)(_constants.LOAD_MORE_META);
      const {
        mediaItems: newMediaItems,
        loadMoreUrl: newUrl
      } = await getMediaItems(loadMoreUrl);
      // istanbul ignore next @preserve --inner not testable
      setMediaItems(currentMediaItems => [...currentMediaItems, ...newMediaItems]);
      setLoadMoreUrl(newUrl);
    }
  }, [getMediaItems, isLoading, loadMoreUrl, setLoadMoreUrl, setMediaItems]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      "data-testid": getTestId(_constants.GALLERY),
      children: mediaItems.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaItem.MediaItem, {
        index: index + 1,
        item: item,
        position: _models.MediaItemPosition.gallery,
        showDetails: onOpenDetails
      }, `${item.id}`))
    }), !!loadMoreUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadMore.LoadMore, {
      isLoading: isLoading,
      onClick: loadMore
    })]
  });
};
exports.OlapicGallery = OlapicGallery;
